import React, {useState} from "react";
import GetProperties from '../properties/get_properties';
import GetRooms from '../rooms/get_rooms';
import Select from 'react-select';
import Form from "react-bootstrap/Form";

function SelectProperty(){
  const Properties = GetProperties();
  const [SelectedProperty, SetSelectedProperty] = useState();

  const [Rooms, SetRooms] = useState();

  const handleSelectedProperty = (event) => {
    SetSelectedProperty(event.value);
  }

  return (
    <Form>
      <Form.Text>
        Select the Property
          <Select
            options={Properties.map(opt => ({ label: opt.name + ", " + opt.address + ", " + opt.parish + ", " + opt.postcode, value: opt.id}))}
            onChange={event => handleSelectedProperty(event)}
            className="mb-3 col-6"
            aria-label="Properties"
          />
      </Form.Text>
    </Form>
  );
}

export default function Sow(){

  return (
    <div>
      {SelectProperty()}
    </div>

  );
}
// Component for Table
